import * as types from '../constants/surveyConstants';

const initialState = {
	questions: {},
	responses: {},
	fspProfile: {},
	isLoadingQuestions: false,
	isLoadingFSPProfile: false,
	isSubmitting: false,
	isComplete: false
};

export default function survey(state = initialState, action) {
	switch (action.type) {
		case types.GET_SURVEY_QUESTIONS:
			return Object.assign({}, state, { isLoadingQuestions: true });
		case types.GET_SURVEY_QUESTIONS_SUCCESS:
			return Object.assign({}, state, { questions: action.questions, isLoadingQuestions: false });
		case types.GET_FSP_PROFILE:
			return Object.assign({}, state, { isLoadingFSPProfile: true });
		case types.GET_FSP_PROFILE_SUCCESS:
			return Object.assign({}, state, { fspProfile: action.profile || {}, isLoadingFSPProfile: false });
		case types.SUBMIT_SURVEY:
			return Object.assign({}, state, { isSubmitting: true });
		case types.SUBMIT_SURVEY_SUCCESS:
			return Object.assign({}, state, { isSubmitting: false, isComplete: action.isComplete });
		case types.SET_SURVEY_RESPONSES:
			return Object.assign({}, state, { responses: action.responses });
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./app/survey/reducers/survey.js